import { isCryptoCode } from "./cryptoUtils";

import { convertCurrencyToCountryCodes } from "./currency-to-countries";

/**
 * @description returns a flag iso given a currency iso
 * @param currencyCode ISO-4217 string | null
 */
export const getCountryCode = (currencyCode: string | null) => {
  if (currencyCode === null) {
    return "XX";
  }

  if (isCryptoCode(currencyCode)) {
    return currencyCode;
  }

  const countries = convertCurrencyToCountryCodes(currencyCode);

  // if a currency is used by multiple countries
  if (countries.length > 1 || countries?.[0] === "XX") {
    return "XX";
  }

  return convertCurrencyToCountryCodes(currencyCode)?.[0];
};
